import {Text, Octicon, Box} from '@primer/react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {ReopenedEvent$key} from './__generated__/ReopenedEvent.graphql'
import {TimelineRow} from './row/TimelineRow'
import {IssueReopenedIcon} from '@primer/octicons-react'

type ReopenedEventProps = {
  queryRef: ReopenedEvent$key
  issueUrl: string
  refAttribute?: React.MutableRefObject<HTMLDivElement | null>
}

export function ReopenedEvent({queryRef, issueUrl, refAttribute}: ReopenedEventProps): JSX.Element {
  const {actor, createdAt, databaseId} = useFragment(
    graphql`
      fragment ReopenedEvent on ReopenedEvent {
        databaseId
        createdAt
        actor {
          ...EventActor
          ...EventActorAvatarItemBadge
        }
      }
    `,
    queryRef,
  )

  return (
    <TimelineRow
      highlighted={false}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      actorAvatar={actor}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      largeAvatar={true}
      leadingIcon={
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'open.fg',
            borderRadius: '50%',
            border:
              'var(--borderWidth-thick, max(2px, 0.125rem)) solid var(--bgColor-default, var(--color-canvas-default))',
            width: '28px',
            height: '28px',
          }}
        >
          <Octicon icon={IssueReopenedIcon} sx={{color: 'white'}} size={16} />
        </Box>
      }
      forMajorEvent={true}
    >
      <Text>{LABELS.timeline.reopenedThis} </Text>
    </TimelineRow>
  )
}

try{ ReopenedEvent.displayName ||= 'ReopenedEvent' } catch {}